// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"Layout_layoutWrapper__ZSkcM","contentWrapper":"Layout_contentWrapper__af4c0"};